angular.module('ui-ng-sibling').directive('sibling', function ($parse) {
  var IS_MESSAGE = /^siblingMessage(.*)/;
  var IS_BROADCAST = /^siblingBroadcast(.*)/;

  return {
    scope: false,
    restrict: 'EA',
    require: '^siblingMediator',
    link: function (scope, element, attrs, siblingMediatorController) {
      _.each(attrs.$attr, function (attr, variable) {
        var channelName;
        var channelExpressionResponse;
        var isMessage = IS_MESSAGE.exec(variable);
        var isBroadcast = IS_BROADCAST.exec(variable);

        if (isMessage !== null) {
          channelName = _.last(isMessage);
        }

        if (isBroadcast !== null) {
          channelName = _.last(isBroadcast);
        }

        if (isMessage !== null || isBroadcast !== null) {
          channelExpressionResponse = $parse(attrs[variable]);

          siblingMediatorController.onMessage(channelName, scope, function (changedValue) {
            scope.$$activeSiblingsMessage = changedValue;
            channelExpressionResponse(scope);
          });
        }

        if (isMessage !== null) {
          scope['notify' + channelName] = function (v) {
            siblingMediatorController.siblingMessage(channelName, scope, v);
          };
        }

        if (isBroadcast !== null && !_.isFunction(scope.$parent['notify' + channelName])) {
          scope.$parent['notify' + channelName] = function (v) {
            siblingMediatorController.siblingBroadcast(channelName, scope, v);
          };
        }
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sibling/src/lib/sibling.js